var map = {
	"./about.jpg": "d4a6",
	"./children.jpg": "ca50",
	"./commercial.jpg": "b78e",
	"./couples.jpg": "cbae",
	"./home.jpg": "a386",
	"./home1.jpg": "4845",
	"./outdoor.jpg": "9d14",
	"./products.jpg": "bf6b",
	"./wedding.jpg": "8710"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "422b";